import React from 'react'
import styled from 'styled-components'
import useTranscriptionLogContext from '~/pages/CallAnalytics/Transcription/context/TranscriptionLogContext'
import { TranscriptEntry, TranscriptItem } from '~/types/CallTranscript'

interface TranscriptWordProps {
  elapsedTimeMillis: number
  beginTime: number
}

const TranscriptWord = styled.span<TranscriptWordProps>`
  color: ${(props) =>
    props.elapsedTimeMillis < props.beginTime
      ? 'var(--chakra-colors-fg-default)'
      : 'var(--chakra-colors-brand-solid)'};
`

interface DynamicTranscriptTextProps {
  index: number
  transcriptEntry: TranscriptEntry
}

const DynamicTranscriptText = ({
  index,
  transcriptEntry,
}: DynamicTranscriptTextProps) => {
  const transcriptLogContext = useTranscriptionLogContext()

  const text = () => {
    let priorTItem: TranscriptItem | null = null
    let itemIndex = 0
    return transcriptEntry.Items.map((tItem: TranscriptItem) => {
      const isPunctuation = tItem.Type === 'punctuation'
      if (isPunctuation) {
        tItem.BeginOffsetMillis = priorTItem?.BeginOffsetMillis ?? 0
      }

      priorTItem = isPunctuation ? priorTItem : tItem
      return (
        <TranscriptWord
          key={`${index}-${itemIndex++}`}
          elapsedTimeMillis={transcriptLogContext.elapsedTimeMillis}
          beginTime={tItem.BeginOffsetMillis}
        >
          {isPunctuation ? tItem.Content : ` ${tItem.Content}`}
        </TranscriptWord>
      )
    })
  }

  return <>{text()}</>
}

export default DynamicTranscriptText
